module.exports = function($) {
    function dropdown(args) {
        let target = (typeof args.target == "string")? $(args.target) : args.target;
        let clicktag = (typeof args.clicktag == "string")? $(args.clicktag) : args.clicktag;
        let f = {
            click: function(){
                $('*').on('click', function(e){
                    if( $(this).parent().closest(args.target).length == 0 ){
                        target.removeClass(args.class);
                    } else {
                        e.stopPropagation();
                    }
                });
                $(clicktag).on(args.event, function(e){
                    e.preventDefault();
                    target.toggleClass(args.class);
                });
            }
        };
        f.click();
    }

    new dropdown({
        'event' : 'click',
        'class' : 'active',
        'clicktag' : '.languages .dropdown-selected',
        'target' : '.dropdown.languages'
    });
}
